<div class="full-screen">
  <app-typeform-form [type]="type" [hiddenFields]="hiddenFields"></app-typeform-form>
</div>
